import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button } from "primereact/button";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { handlePostRequest } from "../../services/PostTemplate";
import { toast } from "react-toastify";
import { JsonToExcel } from "react-json-to-excel";
import { Tooltip } from "react-tippy";
import { handlePutRequest } from "../../services/PutTemplate";
import moment from "moment";
import DialogsMain from "./dialogs/DialogsMain";
import PackagesTable from "./components/PackagesTable";
import { ProgressSpinner } from "primereact/progressspinner";
import useViewOnly from "../../hooks/useViewOnly";
import styles from "./packages.module.scss";
import { checkInvoiceConflicts } from "../../services/invoiceConflictService";
import InvoiceConflictDialog from "../../components/InvoiceConflictDialog";

function Packages() {
    const viewOnly = useViewOnly();
    //only for dialogs
    const [showOutstanding, setShowOutstanding] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [showChangeDialog, setShowChangeDialog] = useState(false);
    const [FlightDialog, setFlightDialog] = useState(false);
    const [packageDetail, setPackageDetail] = useState(false);
    const [uploadShow, setUploadShow] = useState(false);
    const [showSoftStop, setShowSoftStop] = useState(false);
    const [scanPending, setScanPending] = useState(false);
    const [invoiceConflicts, setInvoiceConflicts] = useState([]);
    const [showInvoiceConflicts, setShowInvoiceConflicts] = useState(false);
    const [checkingInvoiceConflicts, setCheckingInvoiceConflicts] = useState(false);
    //

    const [selectedRow, setselectedRow] = useState([]);
    const [brands, setBrands] = useState([]);
    const [skip, setSkip] = useState(0);
    const [role, setrole] = useState("");
    const [userId, setuserId] = useState("");
    const dispatch = useDispatch();
    const [shipment, setShipment] = useState([]);
    const [shipmentNumber, setShipmentNumber] = useState("");
    const [forXL, setForXL] = useState([]);
    const [pack, setPackage] = useState({});
    const [searchedBrands, setSearchedBrands] = useState([]);
    const [loading, setLoading] = useState(true);
    const [del, setDel] = useState();
    const [updates, setUpdates] = useState([]);
    const [wayBills, setWayBills] = useState([]);

    // ✅ NEW: Pagination state
    const [limit, setLimit] = useState(100);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    console.log("Total Records:", totalRecords, "Total Pages:", totalPages, "Current Page:", currentPage);

    // New state for flight search and PDF generation
    const [flightSearchNumber, setFlightSearchNumber] = useState("");
    const [flightPackages, setFlightPackages] = useState([]);
    const [groupedFlightPackages, setGroupedFlightPackages] = useState([]);

    //for datatable
    const [values, setValues] = useState({
        Waybill: "",
        name: "",
        status: "",
        flightNumber: "",
        merchant: "",
        date: "",
        consigneeName: "",
        trackingNumber: "",
        billTo: "",
        deliveryInfo: "",
        bill: "",
        weight: "",
        packageStatus: "",
        role: role,
        userId: userId,
    });
    ////

    //for manifest
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [manifestPackages, setManifestPackages] = useState([]);
    const [flightFilter, setFlightFilter] = useState("");

    ///

    console.log(brands);

    // ✅ FIXED: Updated getBrands with pagination
    const getBrands = async (pageNumber = 1) => {
        setLoading(true);
        let res;
        const calculatedSkip = (pageNumber - 1) * limit;

        try {
            if (role === "admin" || role == "handler" || role === "clerk" || role === "driver") {
                res = await handleGetRequest(`/allPackagesForTable?page=${pageNumber}&limit=${limit}`);
            } else if (role === "courier") {
                const log = localStorage.getItem("Zaziolog");
                if (log) {
                    setShowOutstanding(true);
                }
                res = await handleGetRequest(`/courierpackagesForTable?userid=${userId}&page=${pageNumber}&limit=${limit}`);
            } else if (role === "client" || role === "reseller" || role === "corporate") {
                const log = localStorage.getItem("Zaziolog");
                if (log) {
                    setShowOutstanding(true);
                }
                res = await handleGetRequest(`/clientpackagesForTable?userid=${userId}&page=${pageNumber}&limit=${limit}`);
            }

            console.log(res?.data?.data, "res");
            setBrands(res?.data?.data);
            setSearchedBrands(res?.data?.data);
            setCurrentPage(res?.data?.page);
            setSkip(calculatedSkip);

            // ✅ Get pagination metadata from response headers

            setTotalRecords(res?.data?.totalRecords);
            setTotalPages(res?.data?.totalPages);

            setLoading(false);
        } catch (error) {
            console.error("Error fetching brands:", error);
            setLoading(false);
        }
    };

    // ✅ NEW: Handle page change
    const handlePageChange = (pageNumber) => {
        getBrands(pageNumber);
    };

    const handelDel = async (dat) => {
        setDel(dat);
        setShowSoftStop(true);
    };

    const handles = async () => {
        if (del) {
            const data = {
                id: [del?.Waybill],
            };
            const res = await dispatch(handlePostRequest(data, "/deletePackage", true, true));
            if (res?.success) {
                setDel();
                getBrands(1); // Reset to page 1 after delete
                toast.success("packages deleted");
                window.location.reload();
            }
        }
    };

    const lbToKg = (pounds) => {
        const kilograms = pounds * 0.45359237;
        return kilograms;
    };

    const handledDelete = async () => {
        if (selectedRow?.length > 0) {
            setShowSoftStop(true);
        } else {
            toast.error("Please select atleast one package");
        }
    };

    const handleUpperCase = (name) => {
        return name?.toUpperCase();
    };

    const checkDoubleFLight = (data) => {
        const flight = data.map((val) => {
            return val?.flightNumber;
        });
        const unique = flight.filter((item, i, ar) => ar.indexOf(item) === i);
        if (unique.length === 1) {
            return true;
        } else {
            return false;
        }
    };

    const handleStatusUpdate = () => {
        if (checkDoubleFLight(selectedRow)) {
            const clients = selectedRow.filter((val) => {
                if (val?.consigneeType === "client" || val?.consigneeType === "reseller" || val?.consigneeType === "corporate" || val?.consigneeType === "admin" || val?.consigneeType === "partner") {
                    return val;
                }
            });
            const couriers = selectedRow.filter((val) => {
                if (val?.consigneeType === "courier") {
                    return val;
                }
            });
            const groupedPackages = clients.reduce((groups, pkg) => {
                const { ...packageData } = pkg;

                const existingGroup = groups.find((group) => group?.name === pkg?.name?.firstName + " " + pkg?.name?.lastName);
                if (existingGroup) {
                    existingGroup.description.push(packageData?.description);
                    existingGroup.tracking.push(pkg?.trackingNumber);
                } else {
                    groups.push({
                        id: pkg?.Waybill,
                        name: pkg?.name?.firstName + " " + pkg?.name?.lastName,
                        type: "client",
                        description: [packageData?.description],
                        email: pkg?.name?.email,
                        deliveryInfo: pkg?.deliveryInfo,
                        tracking: [pkg?.trackingNumber],
                        shipmentMethod: pkg?.shipmentMethod,
                        deliveryAddress: pkg?.name?.client?.deliveryAddress,
                    });
                }

                return groups;
            }, []);
            const cos = couriers.reduce((groups, pkg) => {
                const { ...packageData } = pkg;

                const existingGroup = groups.find((group) => group?.name === pkg?.courierName?.courier?.businessName);
                if (existingGroup) {
                    existingGroup.description.push(packageData?.Waybill);
                    existingGroup.tracking.push(pkg?.trackingNumber);
                } else {
                    groups.push({
                        id: pkg?.Waybill,
                        name: pkg?.courierName?.courier?.businessName,
                        type: "courier",
                        description: [packageData?.Waybill],
                        email: pkg?.courierName?.email,
                        deliveryInfo: pkg?.deliveryInfo,
                        tracking: [pkg?.trackingNumber],
                        deliveryAddress: pkg?.courierName?.courier?.deliveryAddress,
                    });
                }

                return groups;
            }, []);
            const final = groupedPackages.concat(cos);
            const ids = selectedRow.map((val) => {
                return val?.Waybill;
            });
            setUpdates(final);
            setWayBills(ids);
            setShowChangeDialog(true);
        } else {
            const flight = selectedRow.map((val) => {
                return val?.flightNumber;
            });
            const unique = flight.filter((item, i, ar) => ar.indexOf(item) === i);
            toast.error(`Please select same flight number, you have selected ${unique.join(",")} flight numbers.`);
        }
    };

    const submitGenerateInvoice = async (waybills) => {
        const dat = {
            status: "Ready for Flight",
            package: updates,
            ids: waybills,
        };
        const res = await handlePutRequest(dat, "/packageInvoice");
        if (res?.success) {
            toast.success("invoices generated successfully");
        }
    };

    const handleGenerateInvoice = async () => {
        const selectedIds = selectedRow.map((val) => {
            return val?.Waybill;
        });

        setCheckingInvoiceConflicts(true);
        let foundConflicts;
        try {
            foundConflicts = await checkInvoiceConflicts(selectedIds);
        } finally {
            setCheckingInvoiceConflicts(false);
        }

        if (foundConflicts.length > 0) {
            setInvoiceConflicts(foundConflicts);
            setShowInvoiceConflicts(true);
            return;
        }

        await submitGenerateInvoice(selectedIds);
    };

    const handleRemoveConflictsAndGenerate = async (conflictWaybills) => {
        setShowInvoiceConflicts(false);
        const selectedIds = selectedRow.map((val) => val?.Waybill);
        const remaining = selectedIds.filter((w) => !conflictWaybills.includes(w));
        await submitGenerateInvoice(remaining);
    };

    const handleCancelInvoiceConflicts = () => {
        setShowInvoiceConflicts(false);
        setInvoiceConflicts([]);
    };

    const downloadCSV = () => {
        try {
            const tempBrands = manifestPackages.map((val) => ({
                Waybill: val?.Waybill || "",
                packageName: val?.billTo || "",
                billTo: val?.consigneeName || "",
                shipmentNumber: val?.flightNumber || "",
                courierName: val?.courierName?.courier?.businessName || "",
                trackingNumber: val?.trackingNumber || "",
                deliveryInfo: val?.deliveryInfo || "",
                weight: (val?.weight?.number || "") + " " + (val?.weight?.unit || ""),
                description: val?.description || "",
            }));

            const headers = Object.keys(tempBrands[0]).join(",") + "\n";

            const rows = tempBrands
                .map((row) =>
                    Object.values(row)
                        .map((value) => `"${value}"`)
                        .join(","),
                )
                .join("\n");

            const csv = headers + rows;
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);

            link.href = url;
            link.download = "Package_Export.csv";
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            setStartDate("");
            setEndDate("");
            setManifestPackages([]);
        } catch (error) {
            console.error("Error generating CSV:", error);
        }
    };

    // New function to search packages by flight number
    const handleFlightSearch = async () => {
        if (!flightSearchNumber.trim()) {
            toast.error("Please enter a flight number");
            return;
        }

        try {
            setLoading(true);

            // Fetch ALL matching packages from backend (use a large limit to get everything for PDF)
            const result = await handleGetRequest(`/searchPackage?flightNumber=${encodeURIComponent(flightSearchNumber.trim())}&limit=10000`);

            const filtered = result?.data?.data || [];

            if (filtered.length === 0) {
                toast.error("No packages found for this flight number");
                setFlightPackages([]);
                setGroupedFlightPackages([]);
                setLoading(false);
                return;
            }

            setFlightPackages(filtered);

            // Group packages by customer name
            const grouped = filtered.reduce((acc, pkg) => {
                const customerName = `${pkg?.name?.firstName || ""} ${pkg?.name?.lastName || ""}`.trim() || "Unknown Customer";

                if (!acc[customerName]) {
                    acc[customerName] = [];
                }

                acc[customerName].push(pkg);

                return acc;
            }, {});

            setGroupedFlightPackages(grouped);
            toast.success(`Found ${filtered.length} packages for flight ${flightSearchNumber}`);
        } catch (error) {
            console.error("Flight search failed:", error);
            toast.error("Failed to search packages by flight number");
            setFlightPackages([]);
            setGroupedFlightPackages([]);
        } finally {
            setLoading(false);
        }
    };

    // New function to generate PDF using print
    const generateFlightPDF = () => {
        if (Object.keys(groupedFlightPackages).length === 0) {
            toast.error("No packages to generate PDF");
            return;
        }

        // Create a new window for printing
        const printWindow = window.open("", "_blank");

        let htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Flight ${flightSearchNumber} - Package Report</title>
                <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    body {
                        font-family: Arial, sans-serif;
                        padding: 20px;
                        font-size: 12px;
                    }
                    .header {
                        text-align: center;
                        margin-bottom: 20px;
                        border-bottom: 2px solid #333;
                        padding-bottom: 10px;
                    }
                    .header h1 {
                        font-size: 20px;
                        margin-bottom: 5px;
                    }
                    .header p {
                        font-size: 11px;
                        color: #666;
                    }
                    .customer-section {
                        margin-bottom: 30px;
                        page-break-inside: avoid;
                    }
                    .customer-name {
                        font-size: 14px;
                        font-weight: bold;
                        margin-bottom: 10px;
                        padding: 8px;
                        background-color: #f0f0f0;
                        border-left: 4px solid #428bca;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 15px;
                    }
                    th {
                        background-color: #428bca;
                        color: white;
                        padding: 10px;
                        text-align: left;
                        font-weight: bold;
                    }
                    td {
                        padding: 8px;
                        border: 1px solid #ddd;
                    }
                    tr:nth-child(even) {
                        background-color: #f9f9f9;
                    }
                    .footer {
                        margin-top: 30px;
                        text-align: center;
                        font-size: 10px;
                        color: #666;
                        border-top: 1px solid #ddd;
                        padding-top: 10px;
                    }
                    @media print {
                        body {
                            padding: 15px;
                        }
                        .customer-section {
                            page-break-inside: avoid;
                        }
                        @page {
                            margin: 1cm;
                        }
                    }
                </style>
            </head>
            <body>
                <div class="header">
                    <h1>Flight ${flightSearchNumber} - Package Report</h1>
                    <p>Generated: ${moment().format("DD-MM-YYYY HH:mm")}</p>
                    <p>Total Packages: ${flightPackages.length} | Customers: ${Object.keys(groupedFlightPackages).length}</p>
                </div>
        `;

        // Loop through each customer
        Object.entries(groupedFlightPackages).forEach(([customerName, packages], index) => {
            htmlContent += `
                <div class="customer-section">
                    <div class="customer-name">${index + 1}. ${customerName}</div>
                    <table>
                        <thead>
                            <tr>
                                <th>Waybill</th>
                                <th>Bill To</th>
                                <th>Weight</th>
                                <th>Cosignee Name</th>
                                <th>Delivery Information</th>
                                <th>Qty</th>
                                <th>Payment Status</th>
                            </tr>
                        </thead>
                        <tbody>
            `;

            packages.forEach((pkg) => {
                const wayBill = pkg?.Waybill || "N/A";
                const billTo = pkg?.name?.firstName + " " + pkg?.name?.lastName || "N/A";
                const weight = `${pkg?.weight?.number || 0} ${pkg?.weight?.unit || "lb"}`;
                const consigneeName = pkg?.consigneeName || "N/A";
                const deliveryInfo = pkg?.deliveryInfo || "N/A";
                const pieces = pkg?.numberOfPieces || "N/A";
                const paymentStatus = pkg?.isPaid ? "Paid" : "Unpaid";

                htmlContent += `
                    <tr>
                        <td>${wayBill}</td>
                        <td>${billTo}</td>
                        <td>${weight}</td>
                        <td>${consigneeName}</td>
                        <td>${deliveryInfo}</td>
                        <td>${pieces}</td>
                        ${pkg?.consigneeType === "client" ? `<td>${paymentStatus}</td>` : ""}
                    </tr>
                `;
            });

            htmlContent += `
                        </tbody>
                    </table>
                </div>
            `;
        });

        htmlContent += `
                <div class="footer">
                    <p>WeMove4wd - Move Your World 🌎</p>
                    <p>This is a computer-generated document. No signature is required.</p>
                </div>
            </body>
            </html>
        `;

        printWindow.document.write(htmlContent);
        printWindow.document.close();

        // Wait for content to load, then print
        printWindow.onload = function () {
            printWindow.focus();
            printWindow.print();
            // Close window after printing (optional)
            // printWindow.close();
        };

        toast.success("PDF print dialog opened");
    };

    useEffect(() => {
        if (selectedRow.length > 0) {
            const temp = selectedRow.map((val) => {
                const data = {
                    id: val?.Waybill,
                    name: val?.name?.firstName + " " + val?.name?.lastName,
                    deliveryAddress: val?.name?.client?.deliveryAddress,
                    email: val?.name?.email,
                };
                return data;
            });
            setShipment(temp);
        }
    }, [selectedRow]);

    // ✅ FIXED: Updated useEffect - removed skip dependency and always start at page 1
    useMemo(() => {
        if (role) {
            getBrands(1);
        }
    }, [role]);

    useEffect(() => {
        const role = localStorage.getItem("role");
        const userId = localStorage.getItem("userId");
        setuserId(userId);
        setrole(role);
        setValues({ ...values, role: role, userId: userId });
    }, []);

    useEffect(() => {
        const dat = searchedBrands;
        const temp = dat.map((val) => {
            return {
                Waybill: handleUpperCase(val?.Waybill),
                CONSIGNEE: handleUpperCase(val?.consigneeName + " C/O Move4wd JA LTD"),
                SHIPPER: handleUpperCase(val?.merchant),
                DESCRIPTION: handleUpperCase(val?.description),
                PCS: val?.numberOfPieces,
                WT: lbToKg(val?.weight?.number),
            };
        });
        setForXL(temp);
    }, [searchedBrands]);

    useEffect(() => {
        if (startDate && endDate) {
            const filteredPackages = searchedBrands.filter((val) => {
                const date = val?.date;
                const start = moment(startDate).format("DD-MM-YYYY");
                const end = moment(endDate).format("DD-MM-YYYY");
                console.log("Date:", date, "Start:", start, "End:", end);
                const showStatus = val?.showStatus;

                console.log("Show Status:", showStatus);

                // Ensure the date is valid before comparing
                if (!date || !start || !end || showStatus === "false") {
                    return false;
                }

                return date >= start && date <= end;
            });

            setManifestPackages(filteredPackages);
        } else if (flightFilter) {
            const filteredPackages = searchedBrands.filter((val) => {
                if (val?.showStatus === "false") {
                    return false;
                }
                return val?.flightNumber === flightFilter;
            });
            setManifestPackages(filteredPackages);
        } else {
            setManifestPackages([]);
        }
    }, [startDate, endDate, searchedBrands, flightFilter]);

    const [tracking, setTacking] = useState();
    const [pendingLoading, setPendingLoading] = useState(false);

    const inputBufferRef = useRef("");

    const handleScan = async (code) => {
        setTacking(code);
        try {
            const data = { trackingNumber: code };
            const pendingRes = await dispatch(handlePostRequest(data, "/getPendingByTracking"));
            const pending = pendingRes?.data;

            if (!pending) {
                toast.error("Package not found.");
                setShowDialog(true);
                return;
            }

            await dispatch(handlePostRequest({ id: pending._id }, "/shiftPendingPackage"));

            const lastPackageRes = await handleGetRequest("/getLastPackage");
            const lastWaybill = lastPackageRes?.data?.Waybill || 1000;
            const lastFlight = lastPackageRes?.data?.flightNumber || "UNKNOWN";

            const currentDate = new Date();
            const formattedDate = `${currentDate.getDate().toString().padStart(2, "0")}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-${currentDate.getFullYear()}`;

            const newPackageData = {
                ...pending,
                Waybill: lastWaybill + 1,
                flightNumber: lastFlight,
                shifted: true,
                name: pending?.billTo,
                billTo: pending.packageName,
                numberOfPieces: pending.quantity,
                courierName: pending?.courier,
                shipmentMethod: "air",
                number: 1,
                unit: "lb",
                trackingNumber: pending.trackingNumber,
                date: formattedDate,
                oversizePackage: false,
                consigneeName: pending.packageName,
                packageType: "perishable",
                deliveryType: "driver",
            };

            delete newPackageData._id;

            const createdRes = await dispatch(handlePostRequest(newPackageData, "/addPackage", true, true));

            if (createdRes !== "error") {
                toast.success("Package created successfully.");
                setPendingLoading(false);
            } else {
                toast.error("Failed to create package.");
            }
        } catch (error) {
            console.error(error);
            toast.error("An error occurred.");
            setPendingLoading(false);
        } finally {
            setPendingLoading(false);
            setTimeout(() => {
                setTacking("");
                setPendingLoading(false);
                getBrands(1); // Reset to page 1 after scan
            }, 1500);
        }
    };

    const [totalPounds, setTotalPounds] = useState(0);

    const calculateTotalPounds = () => {
        const total = searchedBrands.reduce((acc, pkg) => {
            return acc + (pkg?.weight?.number || 0);
        }, 0);
        setTotalPounds(total);
    };

    useEffect(() => {
        calculateTotalPounds();
    }, [searchedBrands]);

    return (
        <>
            <DialogsMain
                showOutstanding={showOutstanding}
                setShowOutstanding={setShowOutstanding}
                showDialog={showDialog}
                setShowDialog={setShowDialog}
                showChangeDialog={showChangeDialog}
                setShowChangeDialog={setShowChangeDialog}
                FlightDialog={FlightDialog}
                setFlightDialog={setFlightDialog}
                packageDetail={packageDetail}
                setPackageDetail={setPackageDetail}
                uploadShow={uploadShow}
                setUploadShow={setUploadShow}
                showSoftStop={showSoftStop}
                setShowSoftStop={setShowSoftStop}
                selectedRow={selectedRow}
                updates={updates}
                wayBills={wayBills}
                pack={pack}
                handles={handles}
                getBrands={() => getBrands(1)}
                scanPending={scanPending}
                setScanPending={setScanPending}
                trackingNumber={tracking}
                unpaid={selectedRow?.filter((val) => val?.isPaid === false)}
            />

            <div className={styles.pageWrapper}>
            <div className={styles.pageHeader}>
                <h2 className={styles.pageTitle}>Packages</h2>
                <div className={styles.actionBar}>
                {selectedRow.length > 0 && <span className={styles.selectedBadge}>{selectedRow.length} selected</span>}
                <div className="Top__Btn">
                    {role === "admin" && (
                        <Tooltip title="Generate Invoices of selected packages" position="bottom" trigger="mouseenter" arrow={true}>
                            {selectedRow.length > 0 && <Button icon="pi pi-wallet" iconPos="right" onClick={handleGenerateInvoice} className="Btn__Blue" disabled={checkingInvoiceConflicts} loading={checkingInvoiceConflicts} />}
                        </Tooltip>
                    )}

                    {(role === "clerk" || role === "admin") && (
                        <Tooltip title="Change status of selected packages" position="bottom" trigger="mouseenter" arrow={true}>
                            {selectedRow.length > 0 && <Button icon="pi pi-file-o" iconPos="right" onClick={handleStatusUpdate} className="Btn__Blue" disabled={viewOnly} />}
                        </Tooltip>
                    )}

                    {(role === "clerk" || role === "admin" || role === "handler") && (
                        <Tooltip title="Change Flight Number of selected packages" position="bottom" trigger="mouseenter" arrow={true}>
                            {selectedRow.length > 0 && <Button icon="pi pi-send" iconPos="right" onClick={() => setFlightDialog(true)} className="Btn__Blue" disabled={viewOnly} />}
                        </Tooltip>
                    )}

                    {(role === "admin" || role === "handler") && (
                        <Tooltip title="Add new Package" position="bottom" trigger="mouseenter" arrow={true}>
                            <Button icon="pi pi-plus" iconPos="right" onClick={() => setShowDialog(true)} className="Btn__Blue" disabled={viewOnly} />
                        </Tooltip>
                    )}

                    {role === "admin" && (
                        <Tooltip title="Delete Selected Packages" position="bottom" trigger="mouseenter" arrow={true}>
                            <Button icon="pi pi-trash" iconPos="right" onClick={handledDelete} className="Btn__DarkDelete" />
                        </Tooltip>
                    )}
                    {(role === "handler" || role === "admin") && (
                        <div className="Top__Btn">
                            <Tooltip title="Download packages in excel" position="bottom" trigger="mouseenter" arrow={true}>
                                <JsonToExcel title=" " class="" data={forXL} fileName={`Flight ${values?.flightNumber}`} btnClassName="buttonsaaa pi pi-download" />
                            </Tooltip>

                            <Tooltip title="Change status of selected packages" position="bottom" trigger="mouseenter" arrow={true}>
                                {selectedRow.length > 0 && <Button icon="pi pi-file-o" iconPos="right" onClick={handleStatusUpdate} className="Btn__Blue" disabled={viewOnly} />}
                            </Tooltip>
                        </div>
                    )}
                </div>
                </div>
            </div>

            {role === "admin" || role === "handler" || role === "clerk" || role === "driver" ? (
                <>
                    {/* {pendingLoading ? (
                        <div>
                            <ProgressSpinner />
                        </div>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", marginTop: "10px", backgroundColor: "#f1f1f1", borderRadius: "10px", padding: "10px", marginBottom: "10px" }}>
                            <label>Scan Pending Packages here...</label>
                            <input placeholder="Tracking#" value={tracking} onChange={(e) => setTacking(e.target.value)}></input>
                        </div>
                    )} */}

                    {/* New Flight Search Section */}
                    <div className={styles.flightSearchCard}>
                        <label className={styles.flightSearchTitle}>Search Packages by Flight Number</label>
                        <div className={styles.flightSearchRow}>
                            <input placeholder="Enter Flight Number" value={flightSearchNumber} onChange={(e) => setFlightSearchNumber(e.target.value)} className={styles.flightSearchInput} />
                            <Button label="Search" icon="pi pi-search" onClick={handleFlightSearch} className="Btn__Blue" />
                            {flightPackages.length > 0 && <Button label="Generate PDF" icon="pi pi-file-pdf" onClick={generateFlightPDF} className="Btn__Blue" />}
                        </div>
                        {flightPackages.length > 0 && (
                            <div className={styles.flightSearchResult}>
                                Found {flightPackages.length} packages for {Object.keys(groupedFlightPackages).length} customers
                            </div>
                        )}
                    </div>
                </>
            ) : null}

            {role === "admin" && (
                <div className={styles.infoCard}>
                    <p style={{ fontWeight: "bold", margin: 0 }}>Total Lbs: {totalPounds}</p>
                </div>
            )}
            {role === "courier" && (
                <div className="package_manifest">
                    <p>Package Export</p>
                    <div className="manifest-inputDiv">
                        <div>
                            <label>Start Date</label>
                            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}></input>
                        </div>
                        <div>
                            <label>End Date</label>
                            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}></input>
                        </div>
                        <div>
                            <label>Flight Number</label>
                            <input type="text" value={flightFilter} onChange={(e) => setFlightFilter(e.target.value)}></input>
                        </div>
                    </div>
                    {manifestPackages?.length > 0 && (
                        <>
                            <div className="manifest-description">
                                <p>Number of packages found: {manifestPackages?.length}</p>
                            </div>
                            <div className="manifestButton">
                                <button onClick={downloadCSV}>Download CSV</button>
                            </div>
                        </>
                    )}
                </div>
            )}

            <div className="card">
                <PackagesTable
                    searchedBrands={searchedBrands}
                    setselectedRow={setselectedRow}
                    selectedRow={selectedRow}
                    loading={loading}
                    role={role}
                    setSearchedBrands={setSearchedBrands}
                    setShipmentNumber={setShipmentNumber}
                    brands={brands}
                    userId={userId}
                    setUploadShow={setUploadShow}
                    setPackage={setPackage}
                    handelDel={handelDel}
                    setPackageDetail={setPackageDetail}
                    setLoading={setLoading}
                    values={values}
                    setValues={setValues}
                    // ✅ NEW: Pagination props
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    limit={limit}
                    onPageChange={handlePageChange}
                />
            </div>
            </div>
            <InvoiceConflictDialog visible={showInvoiceConflicts} conflicts={invoiceConflicts} mode="generate" onRemoveAndContinue={handleRemoveConflictsAndGenerate} onCancel={handleCancelInvoiceConflicts} />
        </>
    );
}

export default Packages;
